import { put, call } from 'redux-saga/effects'
import * as actions from '../action_creators'
import * as client from '../../api/client'

export function* queryTagReports({ queries, team, user, reportOption }) {
    const params = {}
    if (user) {
        params["ownerId"] = user.id
    }
    if (team) {
        params["teamId"] = team.id
    }
    params["tagFilterType"] = reportOption || "AT_LEAST"

    const resp = yield call( client.postTagReportQueries, queries, params )
    if (resp === undefined) return
    yield put( actions.receiveTagReports(resp) )
}



// WEBPACK FOOTER //
// ./src/redux/sagas/tag_report_sagas.js